mutation BatchTransactionDelete($input: BatchTransactionDeleteInput!) {
  batchTransactionDelete(input: $input) {
    clientMutationId
    deletedEntities {
      rowTimestamp
      id
    }
  }
}
